/* eslint-disable no-console */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/function-component-definition */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable jsdoc/require-jsdoc */
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';
import { BluetoothLe } from '@capacitor-community/bluetooth-le';
import { ClipLoader } from 'react-spinners';
import Dropdown from '../controls/DropDown';
import InputBox from '../controls/InputBox';
import Button from '../controls/Button';

// Declare WifiWizard2 in the global window object
declare global {
  interface Window {
    WifiWizard2: any;
  }
}

interface BLEDevice {
  deviceId: string;
  name?: string;
}

interface WiFiCredentialsProps {
  selectedDevices: BLEDevice[];
}

const WiFiCredentials: React.FC<WiFiCredentialsProps> = ({ selectedDevices }) => {
  const [networks, setNetworks] = useState<any[]>([]);
  const [selectedSSID, setSelectedSSID] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [sending, setSending] = useState<boolean>(false);
  const [scanning, setScanning] = useState<boolean>(false);
  const [sendStatus, setSendStatus] = useState<{ [key: string]: 'pending' | 'success' | 'error' }>(
    {}
  );
  const platform = Capacitor.getPlatform();

  const scanWiFiNetworks = async () => {
    console.log('Starting Wi-Fi network scan...');
    setScanning(true);

    try {
      // Check if Wi-Fi is enabled
      const permission = await Geolocation.requestPermissions();
      if (permission.location) {
        console.log('Has permission');
      }
      console.log(permission);
      await Geolocation.getCurrentPosition();
      const isWifiEnabled = await window.WifiWizard2.isWifiEnabled();
      if (!isWifiEnabled) {
        toast.warn('Wi-Fi is not enabled. Please enable Wi-Fi to scan for networks.');
        setScanning(false);
        return;
      }
      console.log('Wi-Fi is enabled. Proceeding with scan...');

      // Start scanning for Wi-Fi networks
      if (platform === 'android') {
        await window.WifiWizard2.scan();

        // After initiating scan, you might not need to explicitly check for permissions
        console.log('Scan initiated. Retrieving available networks...');

        // Get the scan results
        const wifiNetworks = await window.WifiWizard2.getScanResults();
        console.log(`Scan completed. Found ${wifiNetworks.length} networks.`);

        // Log details of each network found
        wifiNetworks.forEach((network: any, index: number) => {
          console.log(`Network ${index + 1}:`);
          console.log(`  SSID: ${network.SSID}`);
          console.log(`  BSSID: ${network.BSSID}`);
          console.log(`  Signal Strength: ${network.level} dBm`);
          console.log(`  Frequency: ${network.frequency} MHz`);
          console.log('--------------------------------');
        });

        // Update state with the found networks
        setNetworks(wifiNetworks);
      } else {
        const ssid = await window.WifiWizard2.getConnectedSSID();
        console.log(ssid);
        setSelectedSSID(ssid);
      }
    } catch (error: any) {
      console.error('Error scanning Wi-Fi networks:', error);
      toast.error('Error scanning WiFi');
      // Handle specific error cases
      if (error?.message?.includes('location services are disabled')) {
        toast.warn('Location services are disabled. Please enable them in settings.');
      } else if (error.message.includes('location permission denied')) {
        toast.warn('Location permission denied. Please enable it in settings.');
      } else {
        toast.error('An unexpected error occurred while scanning Wi-Fi networks.');
      }
    } finally {
      setScanning(false);
    }
  };

  useEffect(() => {
    scanWiFiNetworks();
  }, []);

  // Service and characteristic UUIDs for WiFi configuration
  const SERVICE_UUID = 'f0ffffff-ffff-ffff-ffff-ffffffffffff';
  const CHARACTERISTIC_UUID = 'f1ffffff-ffff-ffff-ffff-ffffffffffff';

  const sendCredentialsToBLEDevices = async () => {
    if (!selectedSSID) {
      toast.error('Please select a WiFi network');
      return;
    }

    if (!password) {
      toast.error('Please enter the WiFi password');
      return;
    }

    if (selectedDevices.length === 0) {
      toast.error('No BLE devices selected');
      return;
    }

    setSending(true);

    // Initialize status for all devices
    const initialStatus: { [key: string]: 'pending' | 'success' | 'error' } = {};
    selectedDevices.forEach((device) => {
      initialStatus[device.deviceId] = 'pending';
    });
    setSendStatus(initialStatus);
    try {
      for (const device of selectedDevices) {
        try {
          console.log(`Connecting to device: ${device.name || device.deviceId}`);

          // Connect to the device first
          await BluetoothLe.connect({
            deviceId: device.deviceId,
            timeout: 10000 // Add timeout to prevent hanging
          });

          console.log(`Connected to device: ${device.name || device.deviceId}`);

          // Get services to ensure connection is established
          const bleServices = await BluetoothLe.getServices({
            deviceId: device.deviceId
          });
          console.log(bleServices);

          // Prepare the WiFi credentials as JSON
          const wifiCredentials = JSON.stringify({
            ssid: selectedSSID,
            password
          });

          console.log(`Sending credentials to device: ${device.name || device.deviceId}`);
          console.log(`Credentials: SSID=${selectedSSID}, Password=${password.replace(/./g, '*')}`);
          console.log(`Raw credentials string: ${wifiCredentials}`);

          const serviceExists = bleServices.services.some(
            (service) => service.uuid === SERVICE_UUID
          );
          if (!serviceExists) {
            throw new Error(`Service ${SERVICE_UUID} not found on device`);
          }

          // Convert string to hex format with spaces between bytes
          const encoder = new TextEncoder();
          const uint8Array = encoder.encode(wifiCredentials);
          const hexString = Array.from(uint8Array)
            .map((byte) => byte.toString(16).padStart(2, '0'))
            .join(' ');

          console.log('Hex string value:', hexString);

          // Write the data to the BLE characteristic
          await BluetoothLe.write({
            deviceId: device.deviceId,
            service: SERVICE_UUID,
            characteristic: CHARACTERISTIC_UUID,
            value: hexString,
            timeout: 10000
          });

          console.log(`Successfully sent credentials to device: ${device.name || device.deviceId}`);

          // Update status for this device
          setSendStatus((prev) => ({
            ...prev,
            [device.deviceId]: 'success'
          }));

          toast.success(`Successfully sent WiFi credentials to ${device.name || device.deviceId}`);

          // Disconnect from the device
          await BluetoothLe.disconnect({
            deviceId: device.deviceId
          });
        } catch (error) {
          console.error(`Failed to send data to device ${device.deviceId}:`, error);

          // Log more detailed error information
          if (error instanceof Error) {
            console.error(`Error message: ${error.message}`);
            console.error(`Error stack: ${error.stack}`);
          } else {
            console.error(`Non-Error object thrown:`, JSON.stringify(error));
          }

          // Update status for this device
          setSendStatus((prev) => ({
            ...prev,
            [device.deviceId]: 'error'
          }));

          toast.error(
            `Failed to send WiFi credentials to ${device.name || device.deviceId}: ${
              error instanceof Error ? error.message : 'Unknown error'
            }`
          );

          try {
            // Try to disconnect in case of error
            await BluetoothLe.disconnect({
              deviceId: device.deviceId
            });
          } catch (disconnectError) {
            console.error(`Failed to disconnect from device ${device.deviceId}:`, disconnectError);
          }
        }
      }
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="flex flex-col gap-8 w-full">
      <div className="text-3xl font-bold dark:text-white text-black text-center">
        Connect Devices to Wi-Fi
      </div>
      <div className="text-gray-400 mt-1 text-center">
        Provide Wi-Fi credentials to connect your devices to the internet
      </div>

      <div className="dark:bg-container-700 bg-white p-6 rounded w-full">
        <div className="text-xl dark:text-white text-black font-semibold mb-2">Wi-Fi Settings</div>
        <div className="text-gray-400 mb-6">Select your network and enter the password</div>

        <div className="flex flex-col gap-4">
          {platform !== 'ios' ? (
            <div className="relative">
              <Dropdown
                label="Wi-Fi Network"
                name="wifi-network"
                options={networks}
                field="SSID"
                selected={networks.find((network) => network.SSID === selectedSSID)}
                handleOptionsSelect={(e) => {
                  const selected = JSON.parse(e.target.value);
                  setSelectedSSID(selected.SSID);
                }}
              />
              <Button
                theme="primary"
                size="sm"
                name={scanning ? '' : 'Scan Networks'}
                onClick={scanWiFiNetworks}
                disabled={scanning}
                loading={scanning}
              />
            </div>
          ) : (
            <InputBox
              idname="wifi-network"
              type="text"
              placeholder="Enter Wi-Fi SSID"
              value={selectedSSID}
              onChnage={setSelectedSSID}
              label="Wi-Fi Network"
            />
          )}

          <InputBox
            idname="wifi-password"
            type="password"
            placeholder="Enter Wi-Fi password"
            value={password}
            onChnage={setPassword}
            label="Password"
          />

          <Button
            theme="primary"
            size="sm"
            name={sending ? '' : 'Send to Devices'}
            onClick={sendCredentialsToBLEDevices}
            disabled={sending || !selectedSSID || !password}
            loading={sending}
            isBlockButton
            className="mt-4"
          />
        </div>

        {selectedDevices.length > 0 && (
          <div className="mt-6 border-t border-gray-700 pt-4">
            <h2 className="text-white text-md font-medium mb-3">Selected Devices</h2>
            <ul className="text-white space-y-2">
              {selectedDevices.map((device) => (
                <li
                  key={device.deviceId}
                  className="flex items-center justify-between p-2 bg-gray-800 rounded"
                >
                  <span className="text-sm">{device.name || device.deviceId}</span>
                  <div className="flex items-center">
                    {sendStatus[device.deviceId] === 'success' && (
                      <span className="text-green-500 material-icons-outlined text-sm">
                        check_circle
                      </span>
                    )}
                    {sendStatus[device.deviceId] === 'error' && (
                      <span className="text-red-500 material-icons-outlined text-sm">error</span>
                    )}
                    {sendStatus[device.deviceId] === 'pending' && sending && (
                      <ClipLoader size={16} color="#FFC107" />
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default WiFiCredentials;
